import React from 'react';
import { IoIosArrowDown } from 'react-icons/io';

import * as S from './styles';

interface AccordionWithTitleProps {
	children: any;
	open: boolean;
	setOpen: any;
	title: string;
	contrastItem?: boolean; // quando aberto, coloca margin emcima e embaixo
	arrowDown?: boolean; // caso queira esconder a seta pra baixo, se false ela esconde
}

export default function AccordionWithTitle({
	children,
	open,
	setOpen,
	title,
	contrastItem = true,
	arrowDown = true
}: AccordionWithTitleProps) {
	return (
		<S.container $isOpen={open} $contrastItem={contrastItem}>
			<S.title $isOpen={open} onClick={() => setOpen(!open)}>
				<p>{title}</p>
				{arrowDown && <IoIosArrowDown />}
			</S.title>

			<S.content $isOpen={open}>{children}</S.content>
		</S.container>
	);
}
